import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { hasPermission, removeUndefinedValues } from '../../config-func'
import { OPTIONS_RECRUITMENT, OPTIONS_TYPE_REQUEST, PAGE_SIZE_OPTIONS } from '../../configData'
import { getRegister, ProjectRecommendRegisterDelete, ProjectRecommendRegisterUpdate } from '../../services/projectRecommendservice'
import Card from '../Card'
import TableField from '../common/Table/TableField'
import AuthenticatedLink from '../Export/AuthenticatedLink'
import FilterForm from './FilterForm'
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import Loading from '../Loading';

import ModalCustom from '../common/Modal/ModalCustom'
import FormPost from './FormPost'
import { Button, Form, Space, Tooltip } from 'antd'
import openNotification from '../common/Notification/openNotification '

const ProjectRecommendRegister = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [dataSource, setDataSource] = useState([])
  const [form] = Form.useForm()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [detail, setDetail] = useState({})
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [url, setUrl] = useState('')
  const [filters, setFilters] = useState({
    currentPage: 1,
    pageSize: 10
  })

  const handleSearch = () => {
    if (filters.currentPage === 1) {
      fetchData()
    } else {
      setFilters((prev) => ({ ...prev, currentPage: 1 }))
    }
  }

  async function fetchData() {
    setLoading(true)

    let _dataSource = []
    let _total = 0

    const params = {
      page: filters.currentPage,
      pageSize: filters.pageSize,
      status: filters.status,
      project_recommend_id: filters.project_recommend_id || '',
      type_request: filters.type_request || '',
      start_date:
        (filters?.date && filters?.date[0]?.format('DD/MM/YYYY')) || '',
      end_date: (filters?.date && filters.date[1]?.format('DD/MM/YYYY')) || ''
    }

    try {
      const response = await getRegister(removeUndefinedValues(params || {}))

      // if (response?.code === 0) {
      _total = response?.data?.total
      _dataSource = response?.data?.list
      // }
    } catch (error) {
      openNotification('error', error?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
      setTotal(_total)
      setDataSource(_dataSource)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filters.currentPage, filters.pageSize, filters.reset])
  // -=0-=0-====================================================================================================
  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (filters.currentPage - 1) * filters.pageSize + index + 1
    },
    {
      title: 'Dự án',
      dataIndex: 'project_recommend_info',
      key: 'project_recommend_info',
      width: 200,
      render: (_, record) => {
        return <div>{record?.project_recommend_info?.name}</div>
      }
    },
    {
      title: 'Họ tên',
      dataIndex: 'user_info',
      key: 'user_info',
      width: 150,
      render: (_, record) => {
        return <div>{record?.user_info?.name}</div>
      }
    },
    // { title: 'Quản lý TP', dataIndex: 'name', key: 'name' },
    {
      title: 'Số điện thoại',
      dataIndex: 'user_info',
      key: 'user_info',
      width: 150,
      render: (_, record) => {
        return <div>{record?.user_info?.phone}</div>
      }
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'status',
      width: 200,
      render: (_, record) => {
        const status = OPTIONS_RECRUITMENT.find(opt => opt.value === record?.status);
        return <div>{status?.name || ''}</div>;
      }
    },
    {
      title: 'Nhu cầu',
      dataIndex: 'type_request',
      key: 'type_request',
      width: 150,
      render: (_, record) => {
        return (
          <div>
            {OPTIONS_TYPE_REQUEST.find(
              (item) => item.value === record.type_request
            )?.name || ''}
          </div>
        )
      }
    },
    {
      title: 'Người yêu cầu',
      dataIndex: 'customer_name',
      key: 'customer_name',
      width: 130
    },
    {
      title: 'Email yêu cầu',
      dataIndex: 'customer_email',
      key: 'customer_email',
      width: 150,
    },
    {
      title: 'SĐT yêu cầu',
      dataIndex: 'customer_phone',
      key: 'customer_phone',
      width: 150,
    },
    {
      title: 'Ngày yêu cầu',
      dataIndex: 'date_view',
      key: 'date_view',
      width: 150,
      render: (_, record) => (
        <span>
          {record?.date_view
            ? dayjs(record.date_view).format('HH:mm:ss DD/MM/YYYY')
            : ''}
        </span>
      )
    },
    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      width: 150,
      render: (_, record) => {
        return (
          <Space size="small">
            {hasPermission('P47.2', permissions) && (
              <Tooltip title="Chỉnh sửa">
                <Button
                  style={{ width: 32 }}
                  icon={<EditOutlined />}
                  onClick={() => {
                    setIsModalOpen(true)
                  setDetail(record)
                    // getDetailImess(record.id)
                  }}
                />
              </Tooltip>
            )}

            {
              hasPermission('P47.3', permissions) && (
                <Tooltip title="Xóa">
                  <Button
                    style={{ width: 32 }}
                    icon={<DeleteOutlined style={{ color: 'red' }} />}
                    onClick={() =>
                      showConfirm({
                        title: 'Xác nhận xoá',
                        content: (
                          <div>
                            Bạn có chắc chắn muốn xoá imess
                            <b> {record.name}</b> không?
                          </div>
                        ),
                        onOk: () => handleDelete(record.id)
                      })
                    }
                  />
                </Tooltip>
              )} 
       
          </Space>
        )
      }
    }
  ]

  useEffect(() => {
    const p = {
      sortBy: 'created_at',
      sort: 'ASC',
      page: filters.currentPage,
      pageSize: filters.pageSize,
      project_recommend_id: filters.project_recommend_id || '',
      type_request: filters.type_request || '',
      start_date:
        (filters?.date && filters?.date[0]?.format('DD/MM/YYYY')) || '',
      end_date: (filters?.date && filters.date[1]?.format('DD/MM/YYYY')) || ''
    }

    const params = new URLSearchParams({ ...p })

    setUrl(
      `${process.env.REACT_APP_API_URL}/api/v1/project-recommend/register/export?` +
        params
    )
  }, [filters])

  const handleDelete = async (id) => {
    setLoading(true)
    try {
      const res = await ProjectRecommendRegisterDelete(id)
      fetchData()
      openNotification('success', res.message)
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  const handleSave = async() => {
    setLoading(true)
    try {
      // Validate các trường trong form
      const values = await form.validateFields()
      // Kiểm tra nếu cả hai giá trị đều tồn tại
     
      const res = await ProjectRecommendRegisterUpdate(
        { status: values.status }, 
        detail?.id
      ); 
      if (res) {
      openNotification(
        'success',
       'Cập nhật thành công'
      )
      fetchData()
      setIsModalOpen(false)
            form.resetFields()
     } else {
        openNotification('error', 'Đã có lỗi xảy ra')
      }
    } catch (err) {
      // Lấy danh sách lỗi từ API
      const errors = get(err, 'response.data.message', [])
  
      // Xử lý lỗi nếu là mảng
      const errorMessages = Array.isArray(errors)
        ? errors.map((error) => error.message).join('\n')
        : errors // Nếu không phải mảng, lấy trực tiếp

      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }
  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        ></div>

        <FilterForm
          handleSearch={handleSearch}
          setFilters={setFilters}
          fetchData={fetchData}
        />
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {hasPermission('P47.1', permissions) && (
          <AuthenticatedLink
            url={url}
            filename={
              filters.type_request == 1
                ? 'Danh-sach-xem-can-ho-mau'
                : filters.type_request == 2
                ? 'Danh-sach-nhan-thong-tin'
                : 'Danh-sach-xem-can-ho-va-danh-sach-nhan-thong-tin'
            }
          >
              Export
            </AuthenticatedLink>
          )}
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          dataSource={dataSource}
          scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          pagination={{
            current: filters.currentPage,
            pageSize: filters.pageSize,
            total: total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onShowSizeChange: (current, size) => {
              setFilters((prev) => ({
                ...prev,
                pageSize: size,
                currentPage: 1
              }))
            },
            onChange: (page) => {
              setFilters((prev) => ({ ...prev, currentPage: page }))
            },
            showTotal: (total, range) => `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`,
            locale: { items_per_page: 'bản ghi / trang' }
          }}
          rowKey={(record, index) => index}
          locale={{ emptyText: 'Không có dữ liệu' }}
        />
      </Card>

      <ModalCustom
        title='Chỉnh sửa'
        visible={isModalOpen}
        centered
        width={1200}
        // className="modal-bond"
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            console.log('Validation failed:', error)
            if (error?.errorFields?.length > 0) {
              form.scrollToField(error.errorFields[0].name, {
                behavior: 'smooth',
                block: 'center' // Đảm bảo label không bị che
              })
            }
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
      >
        <FormPost form={form} data={detail} handleSearch={handleSearch}/>
      </ModalCustom>

      <ModalConfirm />
    </div>
  )
}

export default ProjectRecommendRegister
